"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityQuote = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const look_up_entity_1 = require("./look-up.entity");
let OpportunityQuote = class OpportunityQuote {
};
exports.OpportunityQuote = OpportunityQuote;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuote.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "existing_quote_info", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityQuote.prototype, "existingQuoteInfo", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityQuote.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityQuote.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityQuote.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp, { nullable: true }),
    (0, typeorm_1.JoinColumn)({ name: "status_lid" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _a : Object)
], OpportunityQuote.prototype, "status", void 0);
exports.OpportunityQuote = OpportunityQuote = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_quote")
], OpportunityQuote);
